export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_USER = 'SET_USER';

export const SET_BOATS = 'SET_BOATS';
export const ADD_BOAT = 'ADD_BOAT';
export const EDIT_BOAT = 'EDIT_BOAT';

export const SET_EXPERIENCE = 'SET_EXPERIENCE';
export const ADD_EXPERIENCE = 'ADD_EXPERIENCE';
export const EDIT_EXPERIENCE = 'EDIT_EXPERIENCE';

export const SET_RENTER_BOOKINGS = 'SET_RENTER_BOOKINGS';
export const SET_OWNER_BOOKINGS = 'SET_OWNER_BOOKINGS';
export const SET_RENTER_CUSTOM_BOOKING_REQUESTS = 'SET_RENTER_CUSTOM_BOOKING_REQUESTS';
export const SET_OWNER_CUSTOM_BOOKING_REQUESTS = 'SET_OWNER_CUSTOM_BOOKING_REQUESTS';
export const UPDATE_OWNER_CUSTOM_BOOKING_REQUEST = 'UPDATE_OWNER_CUSTOM_BOOKING_REQUEST';
export const UPDATE_RENTER_CUSTOM_BOOKING_REQUEST = 'UPDATE_RENTER_CUSTOM_BOOKING_REQUEST';

export const SET_OWNER_SHARING_REQUESTS = 'SET_OWNER_SHARING_REQUESTS';
export const UPDATE_OWNER_SHARING_REQUESTS = 'UPDATE_OWNER_SHARING_REQUESTS';